import { Fragment } from 'react';
import intl from 'react-intl-universal';
import { REQUEST_STATUS } from 'utils/constants';
import NavigationButton from './NavigationButton';
import ActionButton from './ActionButton';
import { useRequestContext } from 'Pages/RequestPage/context/RequestContext';

const RequestDetailsButtons = ({
  requestStatus,
  onCancel,
  onSubmit,
  onUpdate,
  hasErrors,
  validRequiredFields,
  changesDetected,
}: {
  requestStatus: string;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
  onUpdate: () => Promise<void>;
  hasErrors: boolean;
  validRequiredFields: boolean;
  changesDetected: boolean;
}) => {
  const {
    areBasicAndRequestDisabled,
    isAdditionalDisabled,
    isLDDisabled,
    isForm,
  } = useRequestContext();

  const disableSaveButtons =
    areBasicAndRequestDisabled &&
    isAdditionalDisabled &&
    isLDDisabled &&
    !isForm;

  const disableSubmitButton =
    areBasicAndRequestDisabled && isAdditionalDisabled && isLDDisabled;

  return (
    <Fragment>
      <div className='flex space-x-4 h-7.5 w-full justify-end'>
        <NavigationButton
          onClickHandler={onCancel}
          variant='tertiary'
          label={intl.get('REQUEST_PAGE.REQUEST_DETAILS.BUTTON.CANCEL')}
        />
        {requestStatus === REQUEST_STATUS.DRAFT ? (
          <Fragment>
            <ActionButton
              testId='request_save-exit-button'
              action={onUpdate}
              variant='secondary'
              hasErrors={hasErrors}
              disabled={disableSaveButtons || !changesDetected}
            >
              {intl.get('REQUEST_PAGE.REQUEST_DETAILS.BUTTON.SAVE_EXIT')}
            </ActionButton>
            <ActionButton
              testId='request_submit-button'
              action={onSubmit}
              variant='primary'
              hasErrors={hasErrors}
              disabled={disableSubmitButton || !validRequiredFields}
            >
              {intl.get('REQUEST_PAGE.REQUEST_DETAILS.BUTTON.SUBMIT')}
            </ActionButton>
          </Fragment>
        ) : (
          <Fragment>
            <ActionButton
              action={onUpdate}
              variant='secondary'
              hasErrors={hasErrors}
              testId='request_update-button'
              disabled={disableSaveButtons || hasErrors}
            >
              {intl.get('REQUEST_PAGE.REQUEST_DETAILS.BUTTON.UPDATE_REQUEST')}
            </ActionButton>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default RequestDetailsButtons;
